(function () {
  'use strict';

  function initStrip(slider) {
    if (!slider || slider.dataset.amiySequenceInit === 'true') return;

    const slides = slider.querySelectorAll('.amiy-slide');
    if (!slides.length) return;

    slider.dataset.amiySequenceInit = 'true';
    let currentSlide = 0;

    function showSlide(index) {
      slides.forEach((slide) => slide.classList.remove('active'));
      slides[index].classList.add('active');
    }

    function nextSlide() {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    }

    slides.forEach((slide) => {
      if (!slide.querySelector('.amiy-slide-text')) {
        const text = (slide.textContent || '').replace(/\s+/g, ' ').trim();
        slide.textContent = '';
        const textSpan = document.createElement('span');
        textSpan.className = 'amiy-slide-text';
        textSpan.textContent = text;
        slide.appendChild(textSpan);
      }
    });

    slides.forEach((slide) => {
      slide.addEventListener('animationend', function (event) {
        if (slide.classList.contains('active') && event.animationName === 'amiy-slide-sequence') {
          nextSlide();
        }
      });
    });

    showSlide(0);
  }

  function initAll() {
    document.querySelectorAll('.amiy-strip-slider').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
